import { h } from 'preact';
import style from './Alert.css';
import Button from '../Button/Button';
import InfoOutlinedIcon from '../Icons/InfoOutlinedIcon';
import CheckIcon from '../Icons/CheckIcon';
import ErrorOutlinedIcon from '../Icons/ErrorOutlinedIcon';
import { renderIf } from '../../../utils/render.utils';
import InfoTriangleIcon from '../Icons/InfoTriangleIcon';

const AlertType = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success',
  MARKETING: 'marketing',
};

const AlertSize = {
  LARGE: 'large',
  COMPACT: 'compact',
};
const icons = {
  [AlertType.INFO]: <InfoOutlinedIcon width={24} height={24} />,
  [AlertType.WARNING]: <InfoTriangleIcon width={24} height={24} />,
  [AlertType.ERROR]: <ErrorOutlinedIcon width={24} height={24} />,
  [AlertType.SUCCESS]: <CheckIcon width={24} height={24} />,
  [AlertType.MARKETING]: <CheckIcon width={24} height={24} />,
};

const AlertIcon = ({ type, icon = null }) => {
  return icon ? icon : icons[type];
};

export default function Alert({
  className = '',
  type = AlertType.INFO,
  size = AlertSize.LARGE,
  hasIcon = false,
  hasButton = false,
  message = '',
  buttonText = '',
  icon = null,
  onButtonClick,
}) {
  return (
    <div
      className={`${className} ${style.alert} ${style[size]} ${style[type]}`}
    >
      <div className={style.inner}>
        {renderIf(
          hasIcon,
          <span className={style['alert-icon']}>
            <AlertIcon type={type} icon={icon} />
          </span>,
        )}
        <div className={style['alert-text']}>{message}</div>

        {renderIf(
          hasButton,
          <Button
            className={style['alert-button']}
            type={Button.Type.TERTIARY}
            size={Button.Size.SMALL}
            onClick={onButtonClick}
          >
            {buttonText}
          </Button>,
        )}
      </div>
    </div>
  );
}

Alert.Type = AlertType;

Alert.Size = AlertSize;
